export default __webpack_public_path__ + "static/media/ucy_koinwnikes_english.f4121b4e.png";